import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '抖音SEO教学平台 - 首页'
    }
  },
  {
    path: '/theory',
    name: 'Theory',
    component: () => import('../views/Theory.vue'),
    meta: {
      title: '抖音SEO教学平台 - 理论学习'
    },
    children: [
      {
        path: 'intro',
        name: 'TheoryIntro',
        component: () => import('../views/theory/Intro.vue'),
        meta: {
          title: '抖音SEO教学平台 - 什么是抖音SEO'
        }
      },
      {
        path: 'why',
        name: 'TheoryWhy',
        component: () => import('../views/theory/Why.vue'),
        meta: {
          title: '抖音SEO教学平台 - 为什么要做抖音SEO'
        }
      },
      {
        path: 'blueocean',
        name: 'TheoryBlueOcean',
        component: () => import('../views/theory/BlueOcean.vue'),
        meta: {
          title: '抖音SEO教学平台 - 抖音SEO是蓝海市场'
        }
      },
      {
        path: 'cases',
        name: 'TheoryCases',
        component: () => import('../views/theory/Cases.vue'),
        meta: {
          title: '抖音SEO教学平台 - 抖音SEO成功案例'
        }
      },
      {
        path: 'algorithm',
        name: 'TheoryAlgorithm',
        component: () => import('../views/theory/Algorithm.vue'),
        meta: {
          title: '抖音SEO教学平台 - 抖音SEO核心算法'
        }
      },
      {
        path: 'strategy',
        name: 'TheoryStrategy',
        component: () => import('../views/theory/Strategy.vue'),
        meta: {
          title: '抖音SEO教学平台 - 抖音SEO实施策略'
        }
      }
    ]
  },
  {
    path: '/practice',
    name: 'Practice',
    component: () => import('../views/Practice.vue'),
    meta: {
      title: '抖音SEO教学平台 - 实战指导'
    },
    children: [
      {
        path: 'account',
        name: 'PracticeAccount',
        component: () => import('../views/practice/Account.vue'),
        meta: {
          title: '抖音SEO教学平台 - 账号搭建'
        }
      },
      {
        path: 'keywords',
        name: 'PracticeKeywords',
        component: () => import('../views/practice/Keywords.vue'),
        meta: {
          title: '抖音SEO教学平台 - 选词与选蓝海词'
        }
      },
      {
        path: 'content',
        name: 'PracticeContent',
        component: () => import('../views/practice/Content.vue'),
        meta: {
          title: '抖音SEO教学平台 - 制作优质内容'
        }
      },
      {
        path: 'publish',
        name: 'PracticePublish',
        component: () => import('../views/practice/Publish.vue'),
        meta: {
          title: '抖音SEO教学平台 - 优化发布策略'
        }
      },
      {
        path: 'analysis',
        name: 'PracticeAnalysis',
        component: () => import('../views/practice/Analysis.vue'),
        meta: {
          title: '抖音SEO教学平台 - 数据分析与调整'
        }
      },
      {
        path: 'advanced',
        name: 'PracticeAdvanced',
        component: () => import('../views/practice/Advanced.vue'),
        meta: {
          title: '抖音SEO教学平台 - 进阶技巧与避坑指南'
        }
      }
    ]
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () => import('../views/Tools.vue'),
    meta: {
      title: '抖音SEO教学平台 - 工具箱'
    }
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue'),
    meta: {
      title: '抖音SEO教学平台 - 成功案例'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
